module.exports = __webpack_public_path__ + "img/B低通10.82b001fd.png";